<template>
  <div class="bar_Box e-flex jc-between box">
    <span class="fs-md fw-6">
      <template v-if="text">
        <div>
          {{ text }}
        </div>
      </template>
      <span class="breadcrumb">
        <slot></slot>
      </span>
    </span>
    <span>带<span class="text-red">*</span>必填</span>
  </div>
</template>
<script>
export default {
  props: {
    text: String,
  },
}
</script>
<style scoped lang="less">
.box {
  height: 60px;
  text-align: center;
  padding: 15px 25px;
  overflow: hidden;
  color: #333333;
  background: #edf5fa;
  margin: 15px auto;
  width: 90%;
  .breadcrumb {
    /deep/ .el-breadcrumb__inner {
      font-weight: 800;
    }
    /deep/ .el-breadcrumb {
      font-size: 1.6rem;
      line-height: inherit;
    }
  }
}
</style>
